
	import { Component } from 'vue-property-decorator';
	import { BaseView } from '@shared/views/BaseView';
	import { BlogTag } from '@shared/models';

	@Component({})
	export default class TagCloud extends BaseView {

		public list: BlogTag[] = [];

		/** Fires when this component is loaded */
		public async mounted() {
			this.loading = true;
			try {
				this.list = await this.$api.blogService.listTags();
			} catch (err) {
				this.errorHandler.handle(err, 'An error occurred while loading the tag cloud');
			} finally {
				this.loading = false;
			}
		}

	}

